/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/content/themes/wrike/dist/js/projects/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 428);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(9)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var core = __webpack_require__(3);
var ctx = __webpack_require__(17);
var hide = __webpack_require__(6);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && key in exports) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(53);
var defined = __webpack_require__(27);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ 12:
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(4);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ 14:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),

/***/ 15:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(35);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _wistiaHelper = __webpack_require__(52);

var _wistiaHelper2 = _interopRequireDefault(_wistiaHelper);

var _lodash = __webpack_require__(63);

var _lodash2 = _interopRequireDefault(_lodash);

var _wg = __webpack_require__(34);

var _wg2 = _interopRequireDefault(_wg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function (global) {
    function Intro() {
        this.$modalVideo = $('#modalVideo');
        this.$socialLink = $('.social__link');
        this.wistiaId = this.$modalVideo.data('wistia-id');
        this.youtubeId = this.$modalVideo.data('youtube-id');

        this.init();
    }

    Intro.prototype.init = function () {
        this.$modalVideo.on('show.wg.modal', function () {
            var _this = this;

            _wg2.default.GdprUserCentrics.makeConditionalCallback(function () {
                if (_this.wistiaId) {
                    _wistiaHelper2.default.appendWistiaVideo(_this.$modalVideo, _this.wistiaId, '', '');
                } else if (_this.youtubeId) {
                    _this.$modalVideo.append('<iframe src="https://www.youtube.com/embed/' + _this.youtubeId + '/?autoplay=true" frameborder="0" allowfullscreen></iframe>');
                }
            }, _wg2.default.GdprUserCentrics.ConsentCategories.Advertising)();
        }.bind(this));

        this.$modalVideo.on('hide.wg.modal', function () {
            this.$modalVideo.children(':not(.modal-video__close)').detach();
        }.bind(this));

        this.initRegistration();
        this.initAirPrTracking();
        this.initSocialModal();
    };

    Intro.prototype.initRegistration = function () {
        var Registration = new _wg2.default.RegistrationNew();

        Registration.setOptions({
            forms: $('.subtitle-form')
        });
        Registration.init();
    };

    Intro.prototype.initSocialModal = function () {
        var socialModalWidth = 600;
        var socialModalHeight = 700;

        if (!this.$socialLink.length) {
            return false;
        }

        this.$socialLink.on('click', function (event) {
            event.preventDefault();
            global.openCenterWindow($(this).attr('href'), 'socialShareModal', socialModalWidth, socialModalHeight);
        });
    };

    Intro.prototype.initAirPrTracking = function () {
        var $trialForm = $('.section-intro .wg-form');

        $trialForm.on('success.wg.registration', function () {
            var addons = $trialForm.data('addons');
            var packages = $trialForm.data('packages');
            var onboarding = $trialForm.data('onboarding');

            var defaultData = {
                value: {
                    email: $(this).find('.global-form__input').val(),
                    form: $(this).data('hash'),
                    plan: $trialForm.data('plan') || 'BIZ_2021',
                    addons: addons,
                    packages: packages,
                    onboarding: onboarding,
                    c_email: window.wrike.cEmail || 'null',
                    existing_user: window.wrike.isUserExisting
                }
            };

            var statSiteData = {
                group: 'trial_forms',
                event: 'trial_form__submit',
                path: window.location.pathname
            };

            var airPrData = {
                event: 'trial_form__submitted'
            };

            global.trackEventForm((0, _lodash2.default)(defaultData, statSiteData));
            new _wg2.default.AirPrTracking((0, _lodash2.default)(defaultData, airPrData));
        });

        $trialForm.on('user.exist.wg.success.registration', function () {
            var addons = $trialForm.data('addons');
            var packages = $trialForm.data('packages');
            var onboarding = $trialForm.data('onboarding');

            var defaultData = {
                value: {
                    email: $(this).find('.global-form__input').val(),
                    form: $(this).data('hash'),
                    plan: $trialForm.data('plan') || 'BIZ_2021',
                    addons: addons,
                    packages: packages,
                    onboarding: onboarding,
                    c_email: window.wrike.cEmail || 'null',
                    existing_user: window.wrike.isUserExisting
                }
            };

            var statSiteDataForExistedUser = {
                group: 'exist_user_form_submit',
                event: 'exist_trial_form__submit',
                path: window.location.pathname
            };

            var airPrDataForExistedUser = {
                event: 'exist_trial_form__submitted'
            };

            global.trackEventForm((0, _lodash2.default)(defaultData, statSiteDataForExistedUser));
            new _wg2.default.AirPrTracking((0, _lodash2.default)(defaultData, airPrDataForExistedUser));
        });
    };

    global.widgets = global.widgets || {};
    global.widgets.Intro = Intro;
})(window.wrike);

/***/ }),

/***/ 157:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


;(function () {
    function FeaturesSlider($elem, options) {
        this.timeSlide = 4000;
        this.timerIntervalId = 0;
        this.autoplay = true;

        $.extend(this, options);

        this.init($elem);
    }

    FeaturesSlider.prototype.init = function ($elem) {
        var featuresSlider = this;

        if (!$elem.length) {
            return false;
        }

        this.$sliderTabs = $elem.find('.features-item__tab');
        this.$sliderImages = $elem.find('.features-item__img');
        this.nextSlideEvent = this.nextSlideEvent || (this.isDesktop ? 'mouseenter' : 'click touchstart');

        if (this.isDesktop) {
            this.start();

            if (this.autoplay) {
                $elem.on('mouseleave', function () {
                    this.refresh();
                }.bind(this));
            }
        }

        this.$sliderTabs.on(this.nextSlideEvent, function () {
            var index = parseInt($(this).attr('data-rel'));

            if (featuresSlider.isDesktop && featuresSlider.autoplay) {
                featuresSlider.stop();
            }

            if ($(this).hasClass('active')) {
                return;
            }

            if (featuresSlider.widgetName === 'PlanWidget') {
                featuresSlider.$sliderImages.parent().toggleClass('feature-group-desktop__img-layers--inverted');
            }

            featuresSlider.$sliderTabs.removeClass('active');
            featuresSlider.$sliderImages.removeClass('is-visible');
            featuresSlider.$sliderTabs.filter('[data-rel=' + index + ']').addClass('active');
            featuresSlider.$sliderImages.filter('[data-rel=' + index + ']').addClass('is-visible');
        });
    };

    FeaturesSlider.prototype.start = function () {
        this.timerIntervalId = setInterval(function () {
            var currentIndex = this.$sliderTabs.filter('.active').attr('data-rel');
            var nextIndex = parseInt(currentIndex) + 1;

            var nextTab = this.$sliderTabs.filter('[data-rel=' + nextIndex + ']');
            var nextImg = this.$sliderImages.filter('[data-rel=' + nextIndex + ']');

            if (!nextTab.length || !nextImg.length) {
                nextTab = this.$sliderTabs.eq(0);
                nextImg = this.$sliderImages.eq(0);
            }

            if (this.widgetName === 'PlanWidget') {
                this.$sliderImages.parent().toggleClass('feature-group-desktop__img-layers--inverted');
            }

            this.$sliderTabs.removeClass('active');
            this.$sliderImages.removeClass('is-visible');

            nextTab.addClass('active');
            nextImg.addClass('is-visible');
        }.bind(this), this.timeSlide);
    };

    FeaturesSlider.prototype.stop = function () {
        clearInterval(this.timerIntervalId);
    };

    FeaturesSlider.prototype.refresh = function () {
        this.stop();
        this.start();
    };

    window.FeaturesSlider = FeaturesSlider;
})();

/***/ }),

/***/ 16:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(4);
var document = __webpack_require__(0).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ 17:
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(19);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ 18:
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ 19:
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(7);
var IE8_DOM_DEFINE = __webpack_require__(21);
var toPrimitive = __webpack_require__(13);
var dP = Object.defineProperty;

exports.f = __webpack_require__(1) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ 20:
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(1) && !__webpack_require__(9)(function () {
  return Object.defineProperty(__webpack_require__(16)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ 22:
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(2).f;
var has = __webpack_require__(8);
var TAG = __webpack_require__(5)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ 23:
/***/ (function(module, exports) {

module.exports = true;


/***/ }),

/***/ 24:
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(41);
var enumBugKeys = __webpack_require__(30);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ 26:
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ 27:
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ 28:
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(29)('keys');
var uid = __webpack_require__(20);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ 29:
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.3' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ 30:
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ 31:
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ 32:
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(5);


/***/ }),

/***/ 33:
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var core = __webpack_require__(3);
var LIBRARY = __webpack_require__(23);
var wksExt = __webpack_require__(32);
var defineProperty = __webpack_require__(2).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),

/***/ 34:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var WG = window.WG;

exports.default = WG;

/***/ }),

/***/ 35:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(36), __esModule: true };

/***/ }),

/***/ 36:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(37);
var $Object = __webpack_require__(3).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(10);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(1), 'Object', { defineProperty: __webpack_require__(2).f });


/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(23);
var $export = __webpack_require__(10);
var redefine = __webpack_require__(40);
var hide = __webpack_require__(6);
var has = __webpack_require__(8);
var Iterators = __webpack_require__(18);
var $iterCreate = __webpack_require__(55);
var setToStringTag = __webpack_require__(22);
var getPrototypeOf = __webpack_require__(51);
var ITERATOR = __webpack_require__(5)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = (!BUGGY && $native) || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(7);
var dPs = __webpack_require__(56);
var enumBugKeys = __webpack_require__(30);
var IE_PROTO = __webpack_require__(28)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(16)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(46).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(6);


/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(8);
var toIObject = __webpack_require__(11);
var arrayIndexOf = __webpack_require__(57)(false);
var IE_PROTO = __webpack_require__(28)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ 42:
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ 428:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(429);
__webpack_require__(430);
__webpack_require__(157);
__webpack_require__(156);

__webpack_require__(431);
__webpack_require__(432);
__webpack_require__(433);
__webpack_require__(434);
__webpack_require__(435);
__webpack_require__(436);
__webpack_require__(437);
__webpack_require__(438);

__webpack_require__(439);
(function () {
    window.apps = window.apps || {};
    window.apps.json = window.appsJson || [];
    window.apps.view = new window.apps.View();
    window.apps.model = new window.apps.Model();
    window.apps.intro = new window.wrike.widgets.Intro();
    window.apps.createWidget = new window.apps.CreateWidget();
    window.apps.planWidget = new window.apps.PlanWidget();
    window.apps.quoteWidget = new window.apps.QuoteWidget();
    window.apps.cardsWidget = new window.apps.CardsWidget();
    window.apps.featuresWidget = new window.apps.FeaturesWidget();
    window.apps.FaqWidget = new window.apps.FaqWidget();
    window.apps.outro = new window.wrike.widgets.Outro();
    window.typeOfPage = 'apps';
})();

/***/ }),

/***/ 429:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = __webpack_require__(59);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * History.js Core
 * @author Benjamin Arthur Lupton <contact@balupton.com>
 * @copyright 2010-2011 Benjamin Arthur Lupton <contact@balupton.com>
 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
 */

;(function (window, undefined) {
	"use strict";

	// ========================================================================
	// Initialise

	// Localise Globals

	var console = window.console || undefined,
	    // Prevent a JSLint complain
	document = window.document,
	    // Make sure we are using the correct document
	navigator = window.navigator,
	    // Make sure we are using the correct navigator
	sessionStorage = false,
	    // sessionStorage
	setTimeout = window.setTimeout,
	    clearTimeout = window.clearTimeout,
	    setInterval = window.setInterval,
	    clearInterval = window.clearInterval,
	    JSON = window.JSON,
	    alert = window.alert,
	    History = window.History = window.History || {},
	    // Public History Object
	history = window.history; // Old History Object

	try {
		sessionStorage = window.sessionStorage; // This will throw an exception in some browsers when cookies/localStorage are explicitly disabled (i.e. Chrome)
		sessionStorage.setItem('TEST', '1');
		sessionStorage.removeItem('TEST');
	} catch (e) {
		sessionStorage = false;
	}

	// MooTools Compatibility
	JSON.stringify = JSON.stringify || JSON.encode;
	JSON.parse = JSON.parse || JSON.decode;

	// Check Existence
	if (typeof History.init !== 'undefined') {
		throw new Error('History.js Core has already been loaded...');
	}

	// Initialise History
	History.init = function (options) {
		// Check Load Status of Adapter
		if (typeof History.Adapter === 'undefined') {
			return false;
		}

		// Check Load Status of Core
		if (typeof History.initCore !== 'undefined') {
			History.initCore();
		}

		// Check Load Status of HTML4 Support
		if (typeof History.initHtml4 !== 'undefined') {
			History.initHtml4();
		}

		// Return true
		return true;
	};

	// ========================================================================
	// Initialise Core

	// Initialise Core
	History.initCore = function (options) {
		// Initialise
		if (typeof History.initCore.initialized !== 'undefined') {
			// Already Loaded
			return false;
		} else {
			History.initCore.initialized = true;
		}

		// ====================================================================
		// Options

		/**
   * History.options
   * Configurable options
   */
		History.options = History.options || {};

		/**
   * History.options.hashChangeInterval
   * How long should the interval be before hashchange checks
   */
		History.options.hashChangeInterval = History.options.hashChangeInterval || 100;

		/**
   * History.options.safariPollInterval
   * How long should the interval be before safari poll checks
   */
		History.options.safariPollInterval = History.options.safariPollInterval || 500;

		/**
   * History.options.doubleCheckInterval
   * How long should the interval be before we perform a double check
   */
		History.options.doubleCheckInterval = History.options.doubleCheckInterval || 500;

		/**
   * History.options.disableSuid
   * Force History not to append suid
   */
		History.options.disableSuid = History.options.disableSuid || false;

		/**
   * History.options.storeInterval
   * How long should we wait between store calls
   */
		History.options.storeInterval = History.options.storeInterval || 1000;

		/**
   * History.options.busyDelay
   * How long should we wait between busy events
   */
		History.options.busyDelay = History.options.busyDelay || 250;

		/**
   * History.options.debug
   * If true will enable debug messages to be logged
   */
		History.options.debug = History.options.debug || false;

		/**
   * History.options.initialTitle
   * What is the title of the initial state
   */
		History.options.initialTitle = History.options.initialTitle || document.title;

		/**
   * History.options.html4Mode
   * If true, will force HTMl4 mode (hashtags)
   */
		History.options.html4Mode = History.options.html4Mode || false;

		/**
   * History.options.delayInit
   * Want to override default options and call init manually.
   */
		History.options.delayInit = History.options.delayInit || false;

		// ====================================================================
		// Interval record

		/**
   * History.intervalList
   * List of intervals set, to be cleared when document is unloaded.
   */
		History.intervalList = [];

		/**
   * History.clearAllIntervals
   * Clears all setInterval instances.
   */
		History.clearAllIntervals = function () {
			var i,
			    il = History.intervalList;
			if (typeof il !== "undefined" && il !== null) {
				for (i = 0; i < il.length; i++) {
					clearInterval(il[i]);
				}
				History.intervalList = null;
			}
		};

		// ====================================================================
		// Debug

		/**
   * History.debug(message,...)
   * Logs the passed arguments if debug enabled
   */
		History.debug = function () {
			if (History.options.debug || false) {
				History.log.apply(History, arguments);
			}
		};

		/**
   * History.log(message,...)
   * Logs the passed arguments
   */
		History.log = function () {
			// Prepare
			var consoleExists = !(typeof console === 'undefined' || typeof console.log === 'undefined' || typeof console.log.apply === 'undefined'),
			    textarea = document.getElementById('log'),
			    message,
			    i,
			    n,
			    args,
			    arg;

			// Write to Console
			if (consoleExists) {
				args = Array.prototype.slice.call(arguments);
				message = args.shift();
				if (typeof console.debug !== 'undefined') {
					console.debug.apply(console, [message, args]);
				} else {
					console.log.apply(console, [message, args]);
				}
			} else {
				message = "\n" + arguments[0] + "\n";
			}

			// Write to log
			for (i = 1, n = arguments.length; i < n; ++i) {
				arg = arguments[i];
				if ((typeof arg === 'undefined' ? 'undefined' : (0, _typeof3.default)(arg)) === 'object' && typeof JSON !== 'undefined') {
					try {
						arg = JSON.stringify(arg);
					} catch (Exception) {
						// Recursive Object
					}
				}
				message += "\n" + arg + "\n";
			}

			// Textarea
			if (textarea) {
				textarea.value += message + "\n-----\n";
				textarea.scrollTop = textarea.scrollHeight - textarea.clientHeight;
			}
			// No Textarea, No Console
			else if (!consoleExists) {
					alert(message);
				}

			// Return true
			return true;
		};

		// ====================================================================
		// Emulated Status

		/**
   * History.getInternetExplorerMajorVersion()
   * Get's the major version of Internet Explorer
   * @return {integer}
   * @license Public Domain
   * @author Benjamin Arthur Lupton <contact@balupton.com>
   * @author James Padolsey <https://gist.github.com/527683>
   */
		History.getInternetExplorerMajorVersion = function () {
			var result = History.getInternetExplorerMajorVersion.cached = typeof History.getInternetExplorerMajorVersion.cached !== 'undefined' ? History.getInternetExplorerMajorVersion.cached : function () {
				var v = 3,
				    div = document.createElement('div'),
				    all = div.getElementsByTagName('i');
				while ((div.innerHTML = '<!--[if gt IE ' + ++v + ']><i></i><![endif]-->') && all[0]) {}
				return v > 4 ? v : false;
			}();
			return result;
		};

		/**
   * History.isInternetExplorer()
   * Are we using Internet Explorer?
   * @return {boolean}
   * @license Public Domain
   * @author Benjamin Arthur Lupton <contact@balupton.com>
   */
		History.isInternetExplorer = function () {
			var result = History.isInternetExplorer.cached = typeof History.isInternetExplorer.cached !== 'undefined' ? History.isInternetExplorer.cached : Boolean(History.getInternetExplorerMajorVersion());
			return result;
		};

		/**
   * History.emulated
   * Which features require emulating?
   */

		if (History.options.html4Mode) {
			History.emulated = {
				pushState: true,
				hashChange: true
			};
		} else {

			History.emulated = {
				pushState: !Boolean(window.history && window.history.pushState && window.history.replaceState && !(/ Mobile\/([1-7][a-z]|(8([abcde]|f(1[0-8]))))/i.test(navigator.userAgent) /* disable for versions of iOS before version 4.3 (8F190) */
				|| /AppleWebKit\/5([0-2]|3[0-2])/i.test(navigator.userAgent) /* disable for the mercury iOS browser, or at least older versions of the webkit engine */
				)),
				hashChange: Boolean(!('onhashchange' in window || 'onhashchange' in document) || History.isInternetExplorer() && History.getInternetExplorerMajorVersion() < 8)
			};
		}

		/**
   * History.enabled
   * Is History enabled?
   */
		History.enabled = !History.emulated.pushState;

		/**
   * History.bugs
   * Which bugs are present
   */
		History.bugs = {
			/**
    * Safari 5 and Safari iOS 4 fail to return to the correct state once a hash is replaced by a `replaceState` call
    * https://bugs.webkit.org/show_bug.cgi?id=56249
    */
			setHash: Boolean(!History.emulated.pushState && navigator.vendor === 'Apple Computer, Inc.' && /AppleWebKit\/5([0-2]|3[0-3])/.test(navigator.userAgent)),

			/**
    * Safari 5 and Safari iOS 4 sometimes fail to apply the state change under busy conditions
    * https://bugs.webkit.org/show_bug.cgi?id=42940
    */
			safariPoll: Boolean(!History.emulated.pushState && navigator.vendor === 'Apple Computer, Inc.' && /AppleWebKit\/5([0-2]|3[0-3])/.test(navigator.userAgent)),

			/**
    * MSIE 6 and 7 sometimes do not apply a hash even it was told to (requiring a second call to the apply function)
    */
			ieDoubleCheck: Boolean(History.isInternetExplorer() && History.getInternetExplorerMajorVersion() < 8),

			/**
    * MSIE 6 requires the entire hash to be encoded for the hashes to trigger the onHashChange event
    */
			hashEscape: Boolean(History.isInternetExplorer() && History.getInternetExplorerMajorVersion() < 7)
		};

		/**
   * History.isEmptyObject(obj)
   * Checks to see if the Object is Empty
   * @param {Object} obj
   * @return {boolean}
   */
		History.isEmptyObject = function (obj) {
			for (var name in obj) {
				if (obj.hasOwnProperty(name)) {
					return false;
				}
			}
			return true;
		};

		/**
   * History.cloneObject(obj)
   * Clones a object and eliminate all references to the original contexts
   * @param {Object} obj
   * @return {Object}
   */
		History.cloneObject = function (obj) {
			var hash, newObj;
			if (obj) {
				hash = JSON.stringify(obj);
				newObj = JSON.parse(hash);
			} else {
				newObj = {};
			}
			return newObj;
		};

		// ====================================================================
		// URL Helpers

		/**
   * History.getRootUrl()
   * Turns "http://mysite.com/dir/page.html?asd" into "http://mysite.com"
   * @return {String} rootUrl
   */
		History.getRootUrl = function () {
			// Create
			var rootUrl = document.location.protocol + '//' + (document.location.hostname || document.location.host);
			if (document.location.port || false) {
				rootUrl += ':' + document.location.port;
			}
			rootUrl += '/';

			// Return
			return rootUrl;
		};

		/**
   * History.getBaseHref()
   * Fetches the `href` attribute of the `<base href="...">` element if it exists
   * @return {String} baseHref
   */
		History.getBaseHref = function () {
			// Create
			var baseElements = document.getElementsByTagName('base'),
			    baseElement = null,
			    baseHref = '';

			// Test for Base Element
			if (baseElements.length === 1) {
				// Prepare for Base Element
				baseElement = baseElements[0];
				baseHref = baseElement.href.replace(/[^\/]+$/, '');
			}

			// Adjust trailing slash
			baseHref = baseHref.replace(/\/+$/, '');
			if (baseHref) baseHref += '/';

			// Return
			return baseHref;
		};

		/**
   * History.getBaseUrl()
   * Fetches the baseHref or basePageUrl or rootUrl (whichever one exists first)
   * @return {String} baseUrl
   */
		History.getBaseUrl = function () {
			// Create
			var baseUrl = History.getBaseHref() || History.getBasePageUrl() || History.getRootUrl();

			// Return
			return baseUrl;
		};

		/**
   * History.getPageUrl()
   * Fetches the URL of the current page
   * @return {String} pageUrl
   */
		History.getPageUrl = function () {
			// Fetch
			var State = History.getState(false, false),
			    stateUrl = (State || {}).url || History.getLocationHref(),
			    pageUrl;

			// Create
			pageUrl = stateUrl.replace(/\/+$/, '').replace(/[^\/]+$/, function (part, index, string) {
				return (/\./.test(part) ? part : part + '/'
				);
			});

			// Return
			return pageUrl;
		};

		/**
   * History.getBasePageUrl()
   * Fetches the Url of the directory of the current page
   * @return {String} basePageUrl
   */
		History.getBasePageUrl = function () {
			// Create
			var basePageUrl = History.getLocationHref().replace(/[#\?].*/, '').replace(/[^\/]+$/, function (part, index, string) {
				return (/[^\/]$/.test(part) ? '' : part
				);
			}).replace(/\/+$/, '') + '/';

			// Return
			return basePageUrl;
		};

		/**
   * History.getFullUrl(url)
   * Ensures that we have an absolute URL and not a relative URL
   * @param {string} url
   * @param {Boolean} allowBaseHref
   * @return {string} fullUrl
   */
		History.getFullUrl = function (url, allowBaseHref) {
			// Prepare
			var fullUrl = url,
			    firstChar = url.substring(0, 1);
			allowBaseHref = typeof allowBaseHref === 'undefined' ? true : allowBaseHref;

			// Check
			if (/[a-z]+\:\/\//.test(url)) {
				// Full URL
			} else if (firstChar === '/') {
				// Root URL
				fullUrl = History.getRootUrl() + url.replace(/^\/+/, '');
			} else if (firstChar === '#') {
				// Anchor URL
				fullUrl = History.getPageUrl().replace(/#.*/, '') + url;
			} else if (firstChar === '?') {
				// Query URL
				fullUrl = History.getPageUrl().replace(/[\?#].*/, '') + url;
			} else {
				// Relative URL
				if (allowBaseHref) {
					fullUrl = History.getBaseUrl() + url.replace(/^(\.\/)+/, '');
				} else {
					fullUrl = History.getBasePageUrl() + url.replace(/^(\.\/)+/, '');
				}
				// We have an if condition above as we do not want hashes
				// which are relative to the baseHref in our URLs
				// as if the baseHref changes, then all our bookmarks
				// would now point to different locations
				// whereas the basePageUrl will always stay the same
			}

			// Return
			return fullUrl.replace(/\#$/, '');
		};

		/**
   * History.getShortUrl(url)
   * Ensures that we have a relative URL and not a absolute URL
   * @param {string} url
   * @return {string} url
   */
		History.getShortUrl = function (url) {
			// Prepare
			var shortUrl = url,
			    baseUrl = History.getBaseUrl(),
			    rootUrl = History.getRootUrl();

			// Trim baseUrl
			if (History.emulated.pushState) {
				// We are in a if statement as when pushState is not emulated
				// The actual url these short urls are relative to can change
				// So within the same session, we the url may end up somewhere different
				shortUrl = shortUrl.replace(baseUrl, '');
			}

			// Trim rootUrl
			shortUrl = shortUrl.replace(rootUrl, '/');

			// Ensure we can still detect it as a state
			if (History.isTraditionalAnchor(shortUrl)) {
				shortUrl = './' + shortUrl;
			}

			// Clean It
			shortUrl = shortUrl.replace(/^(\.\/)+/g, './').replace(/\#$/, '');

			// Return
			return shortUrl;
		};

		/**
   * History.getLocationHref(document)
   * Returns a normalized version of document.location.href
   * accounting for browser inconsistencies, etc.
   *
   * This URL will be URI-encoded and will include the hash
   *
   * @param {object} document
   * @return {string} url
   */
		History.getLocationHref = function (doc) {
			doc = doc || document;

			// most of the time, this will be true
			if (doc.URL === doc.location.href) return doc.location.href;

			// some versions of webkit URI-decode document.location.href
			// but they leave document.URL in an encoded state
			if (doc.location.href === decodeURIComponent(doc.URL)) return doc.URL;

			// FF 3.6 only updates document.URL when a page is reloaded
			// document.location.href is updated correctly
			if (doc.location.hash && decodeURIComponent(doc.location.href.replace(/^[^#]+/, "")) === doc.location.hash) return doc.location.href;

			if (doc.URL.indexOf('#') == -1 && doc.location.href.indexOf('#') != -1) return doc.location.href;

			return doc.URL || doc.location.href;
		};

		// ====================================================================
		// State Storage

		/**
   * History.store
   * The store for all session specific data
   */
		History.store = {};

		/**
   * History.idToState
   * 1-1: State ID to State Object
   */
		History.idToState = History.idToState || {};

		/**
   * History.stateToId
   * 1-1: State String to State ID
   */
		History.stateToId = History.stateToId || {};

		/**
   * History.urlToId
   * 1-1: State URL to State ID
   */
		History.urlToId = History.urlToId || {};

		/**
   * History.storedStates
   * Store the states in an array
   */
		History.storedStates = History.storedStates || [];

		/**
   * History.savedStates
   * Saved the states in an array
   */
		History.savedStates = History.savedStates || [];

		/**
   * History.noramlizeStore()
   * Noramlize the store by adding necessary values
   */
		History.normalizeStore = function () {
			History.store.idToState = History.store.idToState || {};
			History.store.urlToId = History.store.urlToId || {};
			History.store.stateToId = History.store.stateToId || {};
		};

		/**
   * History.getState()
   * Get an object containing the data, title and url of the current state
   * @param {Boolean} friendly
   * @param {Boolean} create
   * @return {Object} State
   */
		History.getState = function (friendly, create) {
			// Prepare
			if (typeof friendly === 'undefined') {
				friendly = true;
			}
			if (typeof create === 'undefined') {
				create = true;
			}

			// Fetch
			var State = History.getLastSavedState();

			// Create
			if (!State && create) {
				State = History.createStateObject();
			}

			// Adjust
			if (friendly) {
				State = History.cloneObject(State);
				State.url = State.cleanUrl || State.url;
			}

			// Return
			return State;
		};

		/**
   * History.getIdByState(State)
   * Gets a ID for a State
   * @param {State} newState
   * @return {String} id
   */
		History.getIdByState = function (newState) {

			// Fetch ID
			var id = History.extractId(newState.url),
			    str;

			if (!id) {
				// Find ID via State String
				str = History.getStateString(newState);
				if (typeof History.stateToId[str] !== 'undefined') {
					id = History.stateToId[str];
				} else if (typeof History.store.stateToId[str] !== 'undefined') {
					id = History.store.stateToId[str];
				} else {
					// Generate a new ID
					while (true) {
						id = new Date().getTime() + String(Math.random()).replace(/\D/g, '');
						if (typeof History.idToState[id] === 'undefined' && typeof History.store.idToState[id] === 'undefined') {
							break;
						}
					}

					// Apply the new State to the ID
					History.stateToId[str] = id;
					History.idToState[id] = newState;
				}
			}

			// Return ID
			return id;
		};

		/**
   * History.normalizeState(State)
   * Expands a State Object
   * @param {object} State
   * @return {object}
   */
		History.normalizeState = function (oldState) {
			// Variables
			var newState, dataNotEmpty;

			// Prepare
			if (!oldState || (typeof oldState === 'undefined' ? 'undefined' : (0, _typeof3.default)(oldState)) !== 'object') {
				oldState = {};
			}

			// Check
			if (typeof oldState.normalized !== 'undefined') {
				return oldState;
			}

			// Adjust
			if (!oldState.data || (0, _typeof3.default)(oldState.data) !== 'object') {
				oldState.data = {};
			}

			// ----------------------------------------------------------------

			// Create
			newState = {};
			newState.normalized = true;
			newState.title = oldState.title || '';
			newState.url = History.getFullUrl(oldState.url ? oldState.url : History.getLocationHref());
			newState.hash = History.getShortUrl(newState.url);
			newState.data = History.cloneObject(oldState.data);

			// Fetch ID
			newState.id = History.getIdByState(newState);

			// ----------------------------------------------------------------

			// Clean the URL
			newState.cleanUrl = newState.url.replace(/\??\&_suid.*/, '');
			newState.url = newState.cleanUrl;

			// Check to see if we have more than just a url
			dataNotEmpty = !History.isEmptyObject(newState.data);

			// Apply
			if ((newState.title || dataNotEmpty) && History.options.disableSuid !== true) {
				// Add ID to Hash
				newState.hash = History.getShortUrl(newState.url).replace(/\??\&_suid.*/, '');
				if (!/\?/.test(newState.hash)) {
					newState.hash += '?';
				}
				newState.hash += '&_suid=' + newState.id;
			}

			// Create the Hashed URL
			newState.hashedUrl = History.getFullUrl(newState.hash);

			// ----------------------------------------------------------------

			// Update the URL if we have a duplicate
			if ((History.emulated.pushState || History.bugs.safariPoll) && History.hasUrlDuplicate(newState)) {
				newState.url = newState.hashedUrl;
			}

			// ----------------------------------------------------------------

			// Return
			return newState;
		};

		/**
   * History.createStateObject(data,title,url)
   * Creates a object based on the data, title and url state params
   * @param {object} data
   * @param {string} title
   * @param {string} url
   * @return {object}
   */
		History.createStateObject = function (data, title, url) {
			// Hashify
			var State = {
				'data': data,
				'title': title,
				'url': url
			};

			// Expand the State
			State = History.normalizeState(State);

			// Return object
			return State;
		};

		/**
   * History.getStateById(id)
   * Get a state by it's UID
   * @param {String} id
   */
		History.getStateById = function (id) {
			// Prepare
			id = String(id);

			// Retrieve
			var State = History.idToState[id] || History.store.idToState[id] || undefined;

			// Return State
			return State;
		};

		/**
   * Get a State's String
   * @param {State} passedState
   */
		History.getStateString = function (passedState) {
			// Prepare
			var State, cleanedState, str;

			// Fetch
			State = History.normalizeState(passedState);

			// Clean
			cleanedState = {
				data: State.data,
				title: passedState.title,
				url: passedState.url
			};

			// Fetch
			str = JSON.stringify(cleanedState);

			// Return
			return str;
		};

		/**
   * Get a State's ID
   * @param {State} passedState
   * @return {String} id
   */
		History.getStateId = function (passedState) {
			// Prepare
			var State, id;

			// Fetch
			State = History.normalizeState(passedState);

			// Fetch
			id = State.id;

			// Return
			return id;
		};

		/**
   * History.getHashByState(State)
   * Creates a Hash for the State Object
   * @param {State} passedState
   * @return {String} hash
   */
		History.getHashByState = function (passedState) {
			// Prepare
			var State, hash;

			// Fetch
			State = History.normalizeState(passedState);

			// Hash
			hash = State.hash;

			// Return
			return hash;
		};

		/**
   * History.extractId(url_or_hash)
   * Get a State ID by it's URL or Hash
   * @param {string} url_or_hash
   * @return {string} id
   */
		History.extractId = function (url_or_hash) {
			// Prepare
			var id, parts, url, tmp;

			// Extract

			// If the URL has a #, use the id from before the #
			if (url_or_hash.indexOf('#') != -1) {
				tmp = url_or_hash.split("#")[0];
			} else {
				tmp = url_or_hash;
			}

			parts = /(.*)\&_suid=([0-9]+)$/.exec(tmp);
			url = parts ? parts[1] || url_or_hash : url_or_hash;
			id = parts ? String(parts[2] || '') : '';

			// Return
			return id || false;
		};

		/**
   * History.isTraditionalAnchor
   * Checks to see if the url is a traditional anchor or not
   * @param {String} url_or_hash
   * @return {Boolean}
   */
		History.isTraditionalAnchor = function (url_or_hash) {
			// Check
			var isTraditional = !/[\/\?\.]/.test(url_or_hash);

			// Return
			return isTraditional;
		};

		/**
   * History.extractState
   * Get a State by it's URL or Hash
   * @param {String} url_or_hash
   * @return {State|null}
   */
		History.extractState = function (url_or_hash, create) {
			// Prepare
			var State = null,
			    id,
			    url;
			create = create || false;

			// Fetch SUID
			id = History.extractId(url_or_hash);
			if (id) {
				State = History.getStateById(id);
			}

			// Fetch SUID returned no State
			if (!State) {
				// Fetch URL
				url = History.getFullUrl(url_or_hash);

				// Check URL
				id = History.getIdByUrl(url) || false;
				if (id) {
					State = History.getStateById(id);
				}

				// Create State
				if (!State && create && !History.isTraditionalAnchor(url_or_hash)) {
					State = History.createStateObject(null, null, url);
				}
			}

			// Return
			return State;
		};

		/**
   * History.getIdByUrl()
   * Get a State ID by a State URL
   */
		History.getIdByUrl = function (url) {
			// Fetch
			var id = History.urlToId[url] || History.store.urlToId[url] || undefined;

			// Return
			return id;
		};

		/**
   * History.getLastSavedState()
   * Get an object containing the data, title and url of the current state
   * @return {Object} State
   */
		History.getLastSavedState = function () {
			return History.savedStates[History.savedStates.length - 1] || undefined;
		};

		/**
   * History.getLastStoredState()
   * Get an object containing the data, title and url of the current state
   * @return {Object} State
   */
		History.getLastStoredState = function () {
			return History.storedStates[History.storedStates.length - 1] || undefined;
		};

		/**
   * History.hasUrlDuplicate
   * Checks if a Url will have a url conflict
   * @param {Object} newState
   * @return {Boolean} hasDuplicate
   */
		History.hasUrlDuplicate = function (newState) {
			// Prepare
			var hasDuplicate = false,
			    oldState;

			// Fetch
			oldState = History.extractState(newState.url);

			// Check
			hasDuplicate = oldState && oldState.id !== newState.id;

			// Return
			return hasDuplicate;
		};

		/**
   * History.storeState
   * Store a State
   * @param {Object} newState
   * @return {Object} newState
   */
		History.storeState = function (newState) {
			// Store the State
			History.urlToId[newState.url] = newState.id;

			// Push the State
			History.storedStates.push(History.cloneObject(newState));

			// Return newState
			return newState;
		};

		/**
   * History.isLastSavedState(newState)
   * Tests to see if the state is the last state
   * @param {Object} newState
   * @return {boolean} isLast
   */
		History.isLastSavedState = function (newState) {
			// Prepare
			var isLast = false,
			    newId,
			    oldState,
			    oldId;

			// Check
			if (History.savedStates.length) {
				newId = newState.id;
				oldState = History.getLastSavedState();
				oldId = oldState.id;

				// Check
				isLast = newId === oldId;
			}

			// Return
			return isLast;
		};

		/**
   * History.saveState
   * Push a State
   * @param {Object} newState
   * @return {boolean} changed
   */
		History.saveState = function (newState) {
			// Check Hash
			if (History.isLastSavedState(newState)) {
				return false;
			}

			// Push the State
			History.savedStates.push(History.cloneObject(newState));

			// Return true
			return true;
		};

		/**
   * History.getStateByIndex()
   * Gets a state by the index
   * @param {integer} index
   * @return {Object}
   */
		History.getStateByIndex = function (index) {
			// Prepare
			var State = null;

			// Handle
			if (typeof index === 'undefined') {
				// Get the last inserted
				State = History.savedStates[History.savedStates.length - 1];
			} else if (index < 0) {
				// Get from the end
				State = History.savedStates[History.savedStates.length + index];
			} else {
				// Get from the beginning
				State = History.savedStates[index];
			}

			// Return State
			return State;
		};

		/**
   * History.getCurrentIndex()
   * Gets the current index
   * @return (integer)
  */
		History.getCurrentIndex = function () {
			// Prepare
			var index = null;

			// No states saved
			if (History.savedStates.length < 1) {
				index = 0;
			} else {
				index = History.savedStates.length - 1;
			}
			return index;
		};

		// ====================================================================
		// Hash Helpers

		/**
   * History.getHash()
   * @param {Location=} location
   * Gets the current document hash
   * Note: unlike location.hash, this is guaranteed to return the escaped hash in all browsers
   * @return {string}
   */
		History.getHash = function (doc) {
			var url = History.getLocationHref(doc),
			    hash;
			hash = History.getHashByUrl(url);
			return hash;
		};

		/**
   * History.unescapeHash()
   * normalize and Unescape a Hash
   * @param {String} hash
   * @return {string}
   */
		History.unescapeHash = function (hash) {
			// Prepare
			var result = History.normalizeHash(hash);

			// Unescape hash
			result = decodeURIComponent(result);

			// Return result
			return result;
		};

		/**
   * History.normalizeHash()
   * normalize a hash across browsers
   * @return {string}
   */
		History.normalizeHash = function (hash) {
			// Prepare
			var result = hash.replace(/[^#]*#/, '').replace(/#.*/, '');

			// Return result
			return result;
		};

		/**
   * History.setHash(hash)
   * Sets the document hash
   * @param {string} hash
   * @return {History}
   */
		History.setHash = function (hash, queue) {
			// Prepare
			var State, pageUrl;

			// Handle Queueing
			if (queue !== false && History.busy()) {
				// Wait + Push to Queue
				//History.debug('History.setHash: we must wait', arguments);
				History.pushQueue({
					scope: History,
					callback: History.setHash,
					args: arguments,
					queue: queue
				});
				return false;
			}

			// Log
			//History.debug('History.setHash: called',hash);

			// Make Busy + Continue
			History.busy(true);

			// Check if hash is a state
			State = History.extractState(hash, true);
			if (State && !History.emulated.pushState) {
				// Hash is a state so skip the setHash
				//History.debug('History.setHash: Hash is a state so skipping the hash set with a direct pushState call',arguments);

				// PushState
				History.pushState(State.data, State.title, State.url, false);
			} else if (History.getHash() !== hash) {
				// Hash is a proper hash, so apply it

				// Handle browser bugs
				if (History.bugs.setHash) {
					// Fix Safari Bug https://bugs.webkit.org/show_bug.cgi?id=56249

					// Fetch the base page
					pageUrl = History.getPageUrl();

					// Safari hash apply
					History.pushState(null, null, pageUrl + '#' + hash, false);
				} else {
					// Normal hash apply
					document.location.hash = hash;
				}
			}

			// Chain
			return History;
		};

		/**
   * History.escape()
   * normalize and Escape a Hash
   * @return {string}
   */
		History.escapeHash = function (hash) {
			// Prepare
			var result = History.normalizeHash(hash);

			// Escape hash
			result = window.encodeURIComponent(result);

			// IE6 Escape Bug
			if (!History.bugs.hashEscape) {
				// Restore common parts
				result = result.replace(/\%21/g, '!').replace(/\%26/g, '&').replace(/\%3D/g, '=').replace(/\%3F/g, '?');
			}

			// Return result
			return result;
		};

		/**
   * History.getHashByUrl(url)
   * Extracts the Hash from a URL
   * @param {string} url
   * @return {string} url
   */
		History.getHashByUrl = function (url) {
			// Extract the hash
			var hash = String(url).replace(/([^#]*)#?([^#]*)#?(.*)/, '$2');

			// Unescape hash
			hash = History.unescapeHash(hash);

			// Return hash
			return hash;
		};

		/**
   * History.setTitle(title)
   * Applies the title to the document
   * @param {State} newState
   * @return {Boolean}
   */
		History.setTitle = function (newState) {
			// Prepare
			var title = newState.title,
			    firstState;

			// Initial
			if (!title) {
				firstState = History.getStateByIndex(0);
				if (firstState && firstState.url === newState.url) {
					title = firstState.title || History.options.initialTitle;
				}
			}

			// Apply
			try {
				document.getElementsByTagName('title')[0].innerHTML = title.replace('<', '&lt;').replace('>', '&gt;').replace(' & ', ' &amp; ');
			} catch (Exception) {}
			document.title = title;

			// Chain
			return History;
		};

		// ====================================================================
		// Queueing

		/**
   * History.queues
   * The list of queues to use
   * First In, First Out
   */
		History.queues = [];

		/**
   * History.busy(value)
   * @param {boolean} value [optional]
   * @return {boolean} busy
   */
		History.busy = function (value) {
			// Apply
			if (typeof value !== 'undefined') {
				//History.debug('History.busy: changing ['+(History.busy.flag||false)+'] to ['+(value||false)+']', History.queues.length);
				History.busy.flag = value;
			}
			// Default
			else if (typeof History.busy.flag === 'undefined') {
					History.busy.flag = false;
				}

			// Queue
			if (!History.busy.flag) {
				// Execute the next item in the queue
				clearTimeout(History.busy.timeout);
				var fireNext = function fireNext() {
					var i, queue, item;
					if (History.busy.flag) return;
					for (i = History.queues.length - 1; i >= 0; --i) {
						queue = History.queues[i];
						if (queue.length === 0) continue;
						item = queue.shift();
						History.fireQueueItem(item);
						History.busy.timeout = setTimeout(fireNext, History.options.busyDelay);
					}
				};
				History.busy.timeout = setTimeout(fireNext, History.options.busyDelay);
			}

			// Return
			return History.busy.flag;
		};

		/**
   * History.busy.flag
   */
		History.busy.flag = false;

		/**
   * History.fireQueueItem(item)
   * Fire a Queue Item
   * @param {Object} item
   * @return {Mixed} result
   */
		History.fireQueueItem = function (item) {
			return item.callback.apply(item.scope || History, item.args || []);
		};

		/**
   * History.pushQueue(callback,args)
   * Add an item to the queue
   * @param {Object} item [scope,callback,args,queue]
   */
		History.pushQueue = function (item) {
			// Prepare the queue
			History.queues[item.queue || 0] = History.queues[item.queue || 0] || [];

			// Add to the queue
			History.queues[item.queue || 0].push(item);

			// Chain
			return History;
		};

		/**
   * History.queue (item,queue), (func,queue), (func), (item)
   * Either firs the item now if not busy, or adds it to the queue
   */
		History.queue = function (item, queue) {
			// Prepare
			if (typeof item === 'function') {
				item = {
					callback: item
				};
			}
			if (typeof queue !== 'undefined') {
				item.queue = queue;
			}

			// Handle
			if (History.busy()) {
				History.pushQueue(item);
			} else {
				History.fireQueueItem(item);
			}

			// Chain
			return History;
		};

		/**
   * History.clearQueue()
   * Clears the Queue
   */
		History.clearQueue = function () {
			History.busy.flag = false;
			History.queues = [];
			return History;
		};

		// ====================================================================
		// IE Bug Fix

		/**
   * History.stateChanged
   * States whether or not the state has changed since the last double check was initialised
   */
		History.stateChanged = false;

		/**
   * History.doubleChecker
   * Contains the timeout used for the double checks
   */
		History.doubleChecker = false;

		/**
   * History.doubleCheckComplete()
   * Complete a double check
   * @return {History}
   */
		History.doubleCheckComplete = function () {
			// Update
			History.stateChanged = true;

			// Clear
			History.doubleCheckClear();

			// Chain
			return History;
		};

		/**
   * History.doubleCheckClear()
   * Clear a double check
   * @return {History}
   */
		History.doubleCheckClear = function () {
			// Clear
			if (History.doubleChecker) {
				clearTimeout(History.doubleChecker);
				History.doubleChecker = false;
			}

			// Chain
			return History;
		};

		/**
   * History.doubleCheck()
   * Create a double check
   * @return {History}
   */
		History.doubleCheck = function (tryAgain) {
			// Reset
			History.stateChanged = false;
			History.doubleCheckClear();

			// Fix IE6,IE7 bug where calling history.back or history.forward does not actually change the hash (whereas doing it manually does)
			// Fix Safari 5 bug where sometimes the state does not change: https://bugs.webkit.org/show_bug.cgi?id=42940
			if (History.bugs.ieDoubleCheck) {
				// Apply Check
				History.doubleChecker = setTimeout(function () {
					History.doubleCheckClear();
					if (!History.stateChanged) {
						//History.debug('History.doubleCheck: State has not yet changed, trying again', arguments);
						// Re-Attempt
						tryAgain();
					}
					return true;
				}, History.options.doubleCheckInterval);
			}

			// Chain
			return History;
		};

		// ====================================================================
		// Safari Bug Fix

		/**
   * History.safariStatePoll()
   * Poll the current state
   * @return {History}
   */
		History.safariStatePoll = function () {
			// Poll the URL

			// Get the Last State which has the new URL
			var urlState = History.extractState(History.getLocationHref()),
			    newState;

			// Check for a difference
			if (!History.isLastSavedState(urlState)) {
				newState = urlState;
			} else {
				return;
			}

			// Check if we have a state with that url
			// If not create it
			if (!newState) {
				//History.debug('History.safariStatePoll: new');
				newState = History.createStateObject();
			}

			// Apply the New State
			//History.debug('History.safariStatePoll: trigger');
			History.Adapter.trigger(window, 'popstate');

			// Chain
			return History;
		};

		// ====================================================================
		// State Aliases

		/**
   * History.back(queue)
   * Send the browser history back one item
   * @param {Integer} queue [optional]
   */
		History.back = function (queue) {
			//History.debug('History.back: called', arguments);

			// Handle Queueing
			if (queue !== false && History.busy()) {
				// Wait + Push to Queue
				//History.debug('History.back: we must wait', arguments);
				History.pushQueue({
					scope: History,
					callback: History.back,
					args: arguments,
					queue: queue
				});
				return false;
			}

			// Make Busy + Continue
			History.busy(true);

			// Fix certain browser bugs that prevent the state from changing
			History.doubleCheck(function () {
				History.back(false);
			});

			// Go back
			history.go(-1);

			// End back closure
			return true;
		};

		/**
   * History.forward(queue)
   * Send the browser history forward one item
   * @param {Integer} queue [optional]
   */
		History.forward = function (queue) {
			//History.debug('History.forward: called', arguments);

			// Handle Queueing
			if (queue !== false && History.busy()) {
				// Wait + Push to Queue
				//History.debug('History.forward: we must wait', arguments);
				History.pushQueue({
					scope: History,
					callback: History.forward,
					args: arguments,
					queue: queue
				});
				return false;
			}

			// Make Busy + Continue
			History.busy(true);

			// Fix certain browser bugs that prevent the state from changing
			History.doubleCheck(function () {
				History.forward(false);
			});

			// Go forward
			history.go(1);

			// End forward closure
			return true;
		};

		/**
   * History.go(index,queue)
   * Send the browser history back or forward index times
   * @param {Integer} queue [optional]
   */
		History.go = function (index, queue) {
			//History.debug('History.go: called', arguments);

			// Prepare
			var i;

			// Handle
			if (index > 0) {
				// Forward
				for (i = 1; i <= index; ++i) {
					History.forward(queue);
				}
			} else if (index < 0) {
				// Backward
				for (i = -1; i >= index; --i) {
					History.back(queue);
				}
			} else {
				throw new Error('History.go: History.go requires a positive or negative integer passed.');
			}

			// Chain
			return History;
		};

		// ====================================================================
		// HTML5 State Support

		// Non-Native pushState Implementation
		if (History.emulated.pushState) {
			/*
    * Provide Skeleton for HTML4 Browsers
    */

			// Prepare
			var emptyFunction = function emptyFunction() {};
			History.pushState = History.pushState || emptyFunction;
			History.replaceState = History.replaceState || emptyFunction;
		} // History.emulated.pushState

		// Native pushState Implementation
		else {
				/*
     * Use native HTML5 History API Implementation
     */

				/**
     * History.onPopState(event,extra)
     * Refresh the Current State
     */
				History.onPopState = function (event, extra) {
					// Prepare
					var stateId = false,
					    newState = false,
					    currentHash,
					    currentState;

					// Reset the double check
					History.doubleCheckComplete();

					// Check for a Hash, and handle apporiatly
					currentHash = History.getHash();
					if (currentHash) {
						// Expand Hash
						currentState = History.extractState(currentHash || History.getLocationHref(), true);
						if (currentState) {
							// We were able to parse it, it must be a State!
							// Let's forward to replaceState
							//History.debug('History.onPopState: state anchor', currentHash, currentState);
							History.replaceState(currentState.data, currentState.title, currentState.url, false);
						} else {
							// Traditional Anchor
							//History.debug('History.onPopState: traditional anchor', currentHash);
							History.Adapter.trigger(window, 'anchorchange');
							History.busy(false);
						}

						// We don't care for hashes
						History.expectedStateId = false;
						return false;
					}

					// Ensure
					stateId = History.Adapter.extractEventData('state', event, extra) || false;

					// Fetch State
					if (stateId) {
						// Vanilla: Back/forward button was used
						newState = History.getStateById(stateId);
					} else if (History.expectedStateId) {
						// Vanilla: A new state was pushed, and popstate was called manually
						newState = History.getStateById(History.expectedStateId);
					} else {
						// Initial State
						newState = History.extractState(History.getLocationHref());
					}

					// The State did not exist in our store
					if (!newState) {
						// Regenerate the State
						newState = History.createStateObject(null, null, History.getLocationHref());
					}

					// Clean
					History.expectedStateId = false;

					// Check if we are the same state
					if (History.isLastSavedState(newState)) {
						// There has been no change (just the page's hash has finally propagated)
						//History.debug('History.onPopState: no change', newState, History.savedStates);
						History.busy(false);
						return false;
					}

					// Store the State
					History.storeState(newState);
					History.saveState(newState);

					// Force update of the title
					History.setTitle(newState);

					// Fire Our Event
					History.Adapter.trigger(window, 'statechange');
					History.busy(false);

					// Return true
					return true;
				};
				History.Adapter.bind(window, 'popstate', History.onPopState);

				/**
     * History.pushState(data,title,url)
     * Add a new State to the history object, become it, and trigger onpopstate
     * We have to trigger for HTML4 compatibility
     * @param {object} data
     * @param {string} title
     * @param {string} url
     * @return {true}
     */
				History.pushState = function (data, title, url, queue) {
					//History.debug('History.pushState: called', arguments);

					// Check the State
					if (History.getHashByUrl(url) && History.emulated.pushState) {
						throw new Error('History.js does not support states with fragement-identifiers (hashes/anchors).');
					}

					// Handle Queueing
					if (queue !== false && History.busy()) {
						// Wait + Push to Queue
						//History.debug('History.pushState: we must wait', arguments);
						History.pushQueue({
							scope: History,
							callback: History.pushState,
							args: arguments,
							queue: queue
						});
						return false;
					}

					// Make Busy + Continue
					History.busy(true);

					// Create the newState
					var newState = History.createStateObject(data, title, url);

					// Check it
					if (History.isLastSavedState(newState)) {
						// Won't be a change
						History.busy(false);
					} else {
						// Store the newState
						History.storeState(newState);
						History.expectedStateId = newState.id;

						// Push the newState
						history.pushState(newState.id, newState.title, newState.url);

						// Fire HTML5 Event
						History.Adapter.trigger(window, 'popstate');
					}

					// End pushState closure
					return true;
				};

				/**
     * History.replaceState(data,title,url)
     * Replace the State and trigger onpopstate
     * We have to trigger for HTML4 compatibility
     * @param {object} data
     * @param {string} title
     * @param {string} url
     * @return {true}
     */
				History.replaceState = function (data, title, url, queue) {
					//History.debug('History.replaceState: called', arguments);

					// Check the State
					if (History.getHashByUrl(url) && History.emulated.pushState) {
						throw new Error('History.js does not support states with fragement-identifiers (hashes/anchors).');
					}

					// Handle Queueing
					if (queue !== false && History.busy()) {
						// Wait + Push to Queue
						//History.debug('History.replaceState: we must wait', arguments);
						History.pushQueue({
							scope: History,
							callback: History.replaceState,
							args: arguments,
							queue: queue
						});
						return false;
					}

					// Make Busy + Continue
					History.busy(true);

					// Create the newState
					var newState = History.createStateObject(data, title, url);

					// Check it
					if (History.isLastSavedState(newState)) {
						// Won't be a change
						History.busy(false);
					} else {
						// Store the newState
						History.storeState(newState);
						History.expectedStateId = newState.id;

						// Push the newState
						history.replaceState(newState.id, newState.title, newState.url);

						// Fire HTML5 Event
						History.Adapter.trigger(window, 'popstate');
					}

					// End replaceState closure
					return true;
				};
			} // !History.emulated.pushState


		// ====================================================================
		// Initialise

		/**
   * Load the Store
   */
		if (sessionStorage) {
			// Fetch
			try {
				History.store = JSON.parse(sessionStorage.getItem('History.store')) || {};
			} catch (err) {
				History.store = {};
			}

			// Normalize
			History.normalizeStore();
		} else {
			// Default Load
			History.store = {};
			History.normalizeStore();
		}

		/**
   * Clear Intervals on exit to prevent memory leaks
   */
		History.Adapter.bind(window, "unload", History.clearAllIntervals);

		/**
   * Create the initial State
   */
		History.saveState(History.storeState(History.extractState(History.getLocationHref(), true)));

		/**
   * Bind for Saving Store
   */
		if (sessionStorage) {
			// When the page is closed
			History.onUnload = function () {
				// Prepare
				var currentStore, item, currentStoreString;

				// Fetch
				try {
					currentStore = JSON.parse(sessionStorage.getItem('History.store')) || {};
				} catch (err) {
					currentStore = {};
				}

				// Ensure
				currentStore.idToState = currentStore.idToState || {};
				currentStore.urlToId = currentStore.urlToId || {};
				currentStore.stateToId = currentStore.stateToId || {};

				// Sync
				for (item in History.idToState) {
					if (!History.idToState.hasOwnProperty(item)) {
						continue;
					}
					currentStore.idToState[item] = History.idToState[item];
				}
				for (item in History.urlToId) {
					if (!History.urlToId.hasOwnProperty(item)) {
						continue;
					}
					currentStore.urlToId[item] = History.urlToId[item];
				}
				for (item in History.stateToId) {
					if (!History.stateToId.hasOwnProperty(item)) {
						continue;
					}
					currentStore.stateToId[item] = History.stateToId[item];
				}

				// Update
				History.store = currentStore;
				History.normalizeStore();

				// In Safari, going into Private Browsing mode causes the
				// Session Storage object to still exist but if you try and use
				// or set any property/function of it it throws the exception
				// "QUOTA_EXCEEDED_ERR: DOM Exception 22: An attempt was made to
				// add something to storage that exceeded the quota." infinitely
				// every second.
				currentStoreString = JSON.stringify(currentStore);
				try {
					// Store
					sessionStorage.setItem('History.store', currentStoreString);
				} catch (e) {
					if (e.code === DOMException.QUOTA_EXCEEDED_ERR) {
						if (sessionStorage.length) {
							// Workaround for a bug seen on iPads. Sometimes the quota exceeded error comes up and simply
							// removing/resetting the storage can work.
							sessionStorage.removeItem('History.store');
							sessionStorage.setItem('History.store', currentStoreString);
						} else {
							// Otherwise, we're probably private browsing in Safari, so we'll ignore the exception.
						}
					} else {
						throw e;
					}
				}
			};

			// For Internet Explorer
			History.intervalList.push(setInterval(History.onUnload, History.options.storeInterval));

			// For Other Browsers
			History.Adapter.bind(window, 'beforeunload', History.onUnload);
			History.Adapter.bind(window, 'unload', History.onUnload);

			// Both are enabled for consistency
		}

		// Non-Native pushState Implementation
		if (!History.emulated.pushState) {
			// Be aware, the following is only for native pushState implementations
			// If you are wanting to include something for all browsers
			// Then include it above this if block

			/**
    * Setup Safari Fix
    */
			if (History.bugs.safariPoll) {
				History.intervalList.push(setInterval(History.safariStatePoll, History.options.safariPollInterval));
			}

			/**
    * Ensure Cross Browser Compatibility
    */
			if (navigator.vendor === 'Apple Computer, Inc.' || (navigator.appCodeName || '') === 'Mozilla') {
				/**
     * Fix Safari HashChange Issue
     */

				// Setup Alias
				History.Adapter.bind(window, 'hashchange', function () {
					History.Adapter.trigger(window, 'popstate');
				});

				// Initialise Alias
				if (History.getHash()) {
					History.Adapter.onDomLoad(function () {
						History.Adapter.trigger(window, 'hashchange');
					});
				}
			}
		} // !History.emulated.pushState

	}; // History.initCore

	// Try to Initialise History
	if (!History.options || !History.options.delayInit) {
		History.init();
	}
})(window);

/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(41);
var hiddenKeys = __webpack_require__(30).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),

/***/ 430:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * History.js jQuery Adapter
 * @author Benjamin Arthur Lupton <contact@balupton.com>
 * @copyright 2010-2011 Benjamin Arthur Lupton <contact@balupton.com>
 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
 */

// Closure
;(function (window, undefined) {
	"use strict";

	// Localise Globals

	var History = window.History = window.History || {},
	    jQuery = window.jQuery;

	// Check Existence
	if (typeof History.Adapter !== 'undefined') {
		throw new Error('History.js Adapter has already been loaded...');
	}

	// Add the Adapter
	History.Adapter = {
		/**
   * History.Adapter.bind(el,event,callback)
   * @param {Element|string} el
   * @param {string} event - custom and standard events
   * @param {function} callback
   * @return {void}
   */
		bind: function bind(el, event, callback) {
			jQuery(el).bind(event, callback);
		},

		/**
   * History.Adapter.trigger(el,event)
   * @param {Element|string} el
   * @param {string} event - custom and standard events
   * @param {Object=} extra - a object of extra event data (optional)
   * @return {void}
   */
		trigger: function trigger(el, event, extra) {
			jQuery(el).trigger(event, extra);
		},

		/**
   * History.Adapter.extractEventData(key,event,extra)
   * @param {string} key - key for the event data to extract
   * @param {string} event - custom and standard events
   * @param {Object=} extra - a object of extra event data (optional)
   * @return {mixed}
   */
		extractEventData: function extractEventData(key, event, extra) {
			// jQuery Native then jQuery Custom
			var result = event && event.originalEvent && event.originalEvent[key] || extra && extra[key] || undefined;

			// Return
			return result;
		},

		/**
   * History.Adapter.onDomLoad(callback)
   * @param {function} callback
   * @return {void}
   */
		onDomLoad: function onDomLoad(callback) {
			jQuery(callback);
		}
	};

	// Try and Initialise History
	if (typeof History.init !== 'undefined') {
		History.init();
	}
})(window);

/***/ }),

/***/ 431:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
    'use strict';

    function CreateWidget() {
        this.$featuresDesktopSlider = $('.create-features-slider--desktop');
        this.$featuresTabletSliders = $('.create-features-slider--tablet');

        this.init();
    }

    CreateWidget.prototype.init = function () {
        new window.FeaturesSlider(this.$featuresDesktopSlider, {
            isDesktop: true
        });

        this.$featuresTabletSliders.each(function () {
            new window.FeaturesSlider($(this));
        });
    };

    window.apps = window.apps || {};
    window.apps.CreateWidget = CreateWidget;
})();

/***/ }),

/***/ 432:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
    'use strict';

    function PlanWidget() {
        this.$featuresDesktopSlider = $('.plan-features-slider--desktop');
        this.$featuresTabletSliders = $('.plan-features-slider--tablet');

        this.init();
    }

    PlanWidget.prototype.init = function () {
        this.$featuresDesktopSlider.each(function () {
            new window.FeaturesSlider($(this), {
                isDesktop: true,
                widgetName: 'PlanWidget'
            });
        });

        this.$featuresTabletSliders.each(function () {
            new window.FeaturesSlider($(this));
        });
    };

    window.apps = window.apps || {};
    window.apps.PlanWidget = PlanWidget;
})();

/***/ }),

/***/ 433:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _wistiaHelper = __webpack_require__(52);

var _wistiaHelper2 = _interopRequireDefault(_wistiaHelper);

var _wg = __webpack_require__(34);

var _wg2 = _interopRequireDefault(_wg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
    /* global */
    'use strict';

    function QuoteWidget() {
        $('.js-video-play').on('click', function () {
            var _this = this;

            _wg2.default.GdprUserCentrics.makeConditionalCallback(function () {
                var $playBtn = $(_this);
                var wistiaId = $playBtn.data('wistia-id') || false;
                var youtubeId = $playBtn.data('youtube-id') || false;

                _this.appendWistiaVideo = _wistiaHelper2.default.appendWistiaVideo || function () {};

                if (youtubeId) {
                    $playBtn.append('<iframe src="https://www.youtube.com/embed/' + $playBtn.data('youtube-id') + '/?autoplay=true" frameborder="0" allowfullscreen></iframe>');
                } else if (wistiaId) {
                    if ($playBtn.hasClass('playing')) {
                        return false;
                    }
                    _this.appendWistiaVideo($playBtn, wistiaId);
                    $playBtn.addClass('playing');
                }
            }, _wg2.default.GdprUserCentrics.ConsentCategories.Advertising)();
        });
    }

    window.apps = window.apps || {};
    window.apps.QuoteWidget = QuoteWidget;
})();

/***/ }),

/***/ 434:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
    'use strict';

    function FeaturesWidget() {
        this.$featuresSlider = $('.features');

        this.init();
    }

    FeaturesWidget.prototype.init = function () {
        this.$featuresSlider.each(function () {
            new window.FeaturesSlider($(this), { isDesktop: true });
        });
    };

    window.apps = window.apps || {};
    window.apps.FeaturesWidget = FeaturesWidget;
})();

/***/ }),

/***/ 435:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _classCallCheck2 = __webpack_require__(14);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaqWidget = function FaqWidget() {
    (0, _classCallCheck3.default)(this, FaqWidget);

    var classFaqQuestion = 'faq-card__question';
    var classFaqCardOpened = 'faq-card--opened';
    var classFaqAnswer = 'faq-card__answer';
    var classFaqAnswerText = 'faq-card__answer-text';

    var $faqQuestion = $('.' + classFaqQuestion);

    $faqQuestion.on('click', function () {
        var $faqCard = $(this).parent();
        var $answer = $faqCard.find('.' + classFaqAnswer);
        var $answerText = $answer.find('.' + classFaqAnswerText);
        var textHeight = void 0;

        $faqCard.toggleClass(classFaqCardOpened);

        if ($faqCard.hasClass(classFaqCardOpened)) {
            textHeight = $answerText[0].getBoundingClientRect().height + 'px';
        } else {
            textHeight = '0';
        }

        $answer.height(textHeight);
    });
};

window.apps = window.apps || {};
window.apps.FaqWidget = FaqWidget;

/***/ }),

/***/ 436:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
    'use strict';

    function Model() {
        this.cardsData = window.apps.json;
    }

    Model.prototype.getCards = function () {
        return this.cardsData;
    };

    Model.prototype.getCardsByCategory = function (categoryLink) {
        var cards = [];
        var cardLink = '';
        var index;

        for (index = 0; index < this.cardsData.length; index++) {
            cardLink = this.cardsData[index].card_link;

            if (cardLink.indexOf(categoryLink) + 1 || cardLink === 'all') {
                cards.push(this.cardsData[index]);
            }
        }

        return cards;
    };

    window.apps = window.apps || {};
    window.apps.Model = Model;
})();

/***/ }),

/***/ 437:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
    'use strict';

    function View() {
        this.$cardsElem = $('.card-list__item');
        this.timeoutHide = 200;
        this.timeoutShow = 250;
    }

    View.prototype.formatCardDefault = function (cardData) {
        var html = '<a href="' + cardData.link + '" class="card-list__item card-list__item--default card-list__item--animation-show">' + '<div class="card-logo" style="background-color:' + cardData.color + '">' + '<img src="' + cardData.logo + '">' + '</div>' + '<div class="card-content">' + '<h5>' + cardData.title + '</h5>' + '<p>' + cardData.description + '</p>' + '<div class="card-content__cat caps">' + cardData.category + '</div></div></a>';

        return html;
    };

    View.prototype.formatCardNew = function (cardData) {
        var html = '<a href="' + cardData.link + '" class="card-list__item card-list__item--new card-list__item--animation-show">' + '<div class="card-img">' + '<img src="' + cardData.image + '">' + '</div><div class="card-content">' + '<div class="card-content__logo"' + 'style="background-image: url(' + cardData.logo + ');' + 'height:' + cardData.logoHeight + 'px;">' + '</div>' + '<div class="card-content__img card-content__img--mobile">' + '<img src="' + cardData.image + '">' + '</div><p>' + cardData.description + '</p>' + '<div class="card-content__cat caps">' + cardData.category + '</div>' + '</div></a>';

        return html;
    };

    View.prototype.formatCardApi = function (cardData) {
        var html = '<div class="card-list__item card-list__item--api card-list__item--animation-show">' + '<div class="card-content">' + '<h5>' + cardData.title + '</h5>' + '<div class="card-content__img card-content__img--mobile">' + '<img src="' + cardData.image + '">' + '</div><p>' + cardData.description + '</p>' + '<a class="wg-btn wg-btn--hollow wg-btn--arrow card-content__link"' + 'href="' + cardData.link + '">' + cardData.text + '<i></i></a>' + '</div><div class="card-img">' + '<img src="' + cardData.image + '">' + '</div></div>';

        return html;
    };

    View.prototype.renderContent = function ($wrap, cards) {
        var html = '';
        var cardData = {};

        cards.forEach(function (card) {
            if (card.class_view === 'card-list__item--default') {
                cardData = {
                    link: card.card_link,
                    color: card.color,
                    logo: card.logo,
                    title: card.title,
                    description: card.description,
                    category: card.category
                };
                html += this.formatCardDefault(cardData);
            } else if (card.class_view === 'card-list__item--new') {
                cardData = {
                    link: card.card_link,
                    image: card.image,
                    logo: card.logo,
                    logoHeight: card.logo_height,
                    description: card.description,
                    category: card.category
                };
                html += this.formatCardNew(cardData);
            } else if (card.class_view === 'card-list__item--api') {
                cardData = {
                    title: card.title,
                    description: card.description,
                    link: card.button_link,
                    text: card.button_text,
                    image: card.image
                };
                html += this.formatCardApi(cardData);
            }
        }.bind(this));

        this.$cardsElem = $('.card-list__item');
        this.$cardsElem.addClass('card-list__item--animation-hide');

        setTimeout(function () {
            $wrap.html(html);
        }, this.timeoutHide);

        setTimeout(function () {
            this.$cardsElem = $('.card-list__item');
            this.$cardsElem.removeClass('card-list__item--animation-show');
        }.bind(this), this.timeoutShow);
    };

    window.apps = window.apps || {};
    window.apps.View = View;
})();

/***/ }),

/***/ 438:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
    'use strict';

    function CardsWidget() {
        this.$catLinks = $('.cat-list__link');
        this.$catMobileLinks = $('.cat-select');
        this.$cardsWrap = $('.card-list');
        this.mainUrl = 'https://' + location.host + '/apps/';
        this.desktopScreenWidth = 1024;
        this.cards = [];
        this.html = '';

        this.init();
    }

    CardsWidget.prototype.init = function () {
        this.switchTabRoute();
        this.animationScroll();

        window.onscroll = function () {
            if (window.innerWidth > this.desktopScreenWidth) {
                this.animationScroll();
            }
        }.bind(this);
    };

    CardsWidget.prototype.render = function (categoryUrl) {
        if (categoryUrl === this.mainUrl) {
            this.cards = window.apps.model.getCards();
        } else {
            this.cards = window.apps.model.getCardsByCategory(location.pathname);
        }

        window.apps.view.renderContent(this.$cardsWrap, this.cards);
    };

    CardsWidget.prototype.switchTabRoute = function () {
        History.Adapter.bind(window, 'statechange', function () {
            var $activeCatLink = $('.cat-list__link.active');
            var categoryUrl = 'https://' + location.host + location.pathname;

            $activeCatLink.removeClass('active');

            this.$catLinks.each(function (index, category) {
                var $category = $(category);

                if ($category.attr('href') === location.pathname) {
                    $category.addClass('active');
                }
            });

            this.render(categoryUrl);
        }.bind(this));

        this.$catLinks.on('click touchstart', function (event) {
            var $link = $(event.target);
            var categoryUrl = $link.prop('href');
            var categoryTitle = $link.html();

            event.preventDefault();
            History.pushState({
                url: categoryUrl
            }, categoryTitle, categoryUrl);
        });

        this.$catMobileLinks.on('change', function (eventMobileTap) {
            var $select = $(this);
            var categoryUrl = 'https://' + location.host + $select.val();
            var categoryTitle = $select.find('option:selected').text();

            eventMobileTap.preventDefault();
            History.pushState({
                url: categoryUrl
            }, categoryTitle, categoryUrl);
        });
    };

    CardsWidget.prototype.animationScroll = function () {
        var $cards = $('.card-list__item');

        $cards.each(function () {
            var $card = $(this);

            if ($(document).scrollTop() + $(window).height() > $card.offset().top + 100 && $(document).scrollTop() - $card.offset().top + 200 < $card.height()) {
                $card.removeClass('card-list__item--minimized');
            }
        });
    };

    window.apps = window.apps || {};
    window.apps.CardsWidget = CardsWidget;
})();

/***/ }),

/***/ 439:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _lodash = __webpack_require__(63);

var _lodash2 = _interopRequireDefault(_lodash);

var _wg = __webpack_require__(34);

var _wg2 = _interopRequireDefault(_wg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function (global) {
    function Outro() {
        this.initRegistration();
        this.initAirPrTracking();
    }

    Outro.prototype.initRegistration = function () {
        var Registration = new _wg2.default.RegistrationNew();

        Registration.setOptions({
            forms: $('.section-common-outro .wg-form')
        });
        Registration.init();
    };

    Outro.prototype.initAirPrTracking = function () {
        var $trialForm = $('.section-common-outro .wg-form');

        $trialForm.on('success.wg.registration', function () {
            var addons = $trialForm.data('addons');
            var packages = $trialForm.data('packages');
            var onboarding = $trialForm.data('onboarding');

            var defaultData = {
                value: {
                    email: $(this).find('.global-form__input').val(),
                    form: $(this).data('hash'),
                    plan: $trialForm.data('plan') || 'BIZ_2021',
                    addons: addons,
                    packages: packages,
                    onboarding: onboarding,
                    c_email: window.wrike.cEmail || 'null',
                    existing_user: window.wrike.isUserExisting
                }
            };

            var statSiteData = {
                group: 'trial_forms',
                event: 'trial_form__submit',
                path: window.location.pathname
            };

            var airPrData = {
                event: 'trial_form__submitted'
            };

            global.trackEventForm((0, _lodash2.default)(defaultData, statSiteData));
            new _wg2.default.AirPrTracking((0, _lodash2.default)(defaultData, airPrData));
        });

        $trialForm.on('user.exist.wg.success.registration', function () {
            var addons = $trialForm.data('addons');
            var packages = $trialForm.data('packages');
            var onboarding = $trialForm.data('onboarding');

            var defaultData = {
                value: {
                    email: $(this).find('.global-form__input').val(),
                    form: $(this).data('hash'),
                    plan: $trialForm.data('plan') || 'BIZ_2021',
                    addons: addons,
                    packages: packages,
                    onboarding: onboarding,
                    c_email: window.wrike.cEmail || 'null',
                    existing_user: window.wrike.isUserExisting
                }
            };

            var statSiteDataForExistedUser = {
                group: 'exist_user_form_submit',
                event: 'exist_trial_form__submit',
                path: window.location.pathname
            };

            var airPrDataForExistedUser = {
                event: 'exist_trial_form__submitted'
            };

            global.trackEventForm((0, _lodash2.default)(defaultData, statSiteDataForExistedUser));
            new _wg2.default.AirPrTracking((0, _lodash2.default)(defaultData, airPrDataForExistedUser));
        });
    };

    global.widgets = global.widgets || {};
    global.widgets.Outro = Outro;
})(window.wrike);

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(27);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(26);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(0).document;
module.exports = document && document.documentElement;


/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(54)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(38)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ 48:
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ 49:
/***/ (function(module, exports) {



/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(29)('wks');
var uid = __webpack_require__(20);
var Symbol = __webpack_require__(0).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(60);
var global = __webpack_require__(0);
var hide = __webpack_require__(6);
var Iterators = __webpack_require__(18);
var TO_STRING_TAG = __webpack_require__(5)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(8);
var toObject = __webpack_require__(44);
var IE_PROTO = __webpack_require__(28)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(14);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(15);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WistiaHelper = function () {
    function WistiaHelper() {
        (0, _classCallCheck3.default)(this, WistiaHelper);
    }

    (0, _createClass3.default)(WistiaHelper, null, [{
        key: 'appendWistiaVideo',
        value: function appendWistiaVideo($target, wistiaId, playerColor, endVideoBehavior) {
            var isModal = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
            var autoPlay = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;

            this.renderVideo($target, wistiaId, playerColor, endVideoBehavior, autoPlay);
        }

        /**
         * Paste wistia video in to the DOM
         * @param {jQuery} $target - where to append video frame
         * @param {string} wistiaId - video id
         * @param {string} playerColor - color for player control panel
         * @param {string} endVideoBehavior - https://wistia.com/doc/embed-options#endvideobehavior
         */

    }, {
        key: 'renderVideo',
        value: function renderVideo($target, wistiaId, playerColor, endVideoBehavior, autoPlay) {
            this.getScriptWistia();

            $target.append('' + '<div class="wistia_responsive_padding">' + '<div class="wistia_responsive_wrapper">' + '<div class="wistia_embed wistia_async_' + wistiaId + ' autoPlay=' + autoPlay + ' playerColor=' + playerColor + ' endVideoBehavior=' + endVideoBehavior + '">&nbsp;</div>' + '</div>' + '</div>');
        }
    }, {
        key: 'getScriptWistia',
        value: function getScriptWistia(videoInstance, callback) {
            if (typeof window.Wistia === 'undefined') {
                $.getScript('https://fast.wistia.com/assets/external/E-v1.js').done(function (script, textStatus) {
                    if (typeof callback === 'function') {
                        callback(videoInstance);
                    }
                });
            } else {
                if (typeof callback === 'function') {
                    callback(videoInstance);
                }
            }
        }
    }]);
    return WistiaHelper;
}();

exports.default = WistiaHelper;

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(24);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(26);
var defined = __webpack_require__(27);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(39);
var descriptor = __webpack_require__(12);
var setToStringTag = __webpack_require__(22);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(6)(IteratorPrototype, __webpack_require__(5)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(2);
var anObject = __webpack_require__(7);
var getKeys = __webpack_require__(25);

module.exports = __webpack_require__(1) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(11);
var toLength = __webpack_require__(45);
var toAbsoluteIndex = __webpack_require__(58);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(26);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(66);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(68);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),

/***/ 6:
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(2);
var createDesc = __webpack_require__(12);
module.exports = __webpack_require__(1) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ 60:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(61);
var step = __webpack_require__(62);
var Iterators = __webpack_require__(18);
var toIObject = __webpack_require__(11);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(38)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ 61:
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),

/***/ 62:
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),

/***/ 63:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    asyncTag = '[object AsyncFunction]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    nullTag = '[object Null]',
    objectTag = '[object Object]',
    proxyTag = '[object Proxy]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    undefinedTag = '[object Undefined]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Gets the value at `key`, unless `key` is "__proto__".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  return key == '__proto__'
    ? undefined
    : object[key];
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    objectCreate = Object.create,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeMax = Math.max,
    nativeNow = Date.now;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    if (isObject(srcValue)) {
      stack || (stack = new Stack);
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = merge;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48), __webpack_require__(64)(module)))

/***/ }),

/***/ 64:
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),

/***/ 65:
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(31);
var createDesc = __webpack_require__(12);
var toIObject = __webpack_require__(11);
var toPrimitive = __webpack_require__(13);
var has = __webpack_require__(8);
var IE8_DOM_DEFINE = __webpack_require__(21);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(1) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(67), __esModule: true };

/***/ }),

/***/ 67:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(47);
__webpack_require__(50);
module.exports = __webpack_require__(32).f('iterator');


/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(69), __esModule: true };

/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(70);
__webpack_require__(49);
__webpack_require__(75);
__webpack_require__(76);
module.exports = __webpack_require__(3).Symbol;


/***/ }),

/***/ 7:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(4);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ 70:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(0);
var has = __webpack_require__(8);
var DESCRIPTORS = __webpack_require__(1);
var $export = __webpack_require__(10);
var redefine = __webpack_require__(40);
var META = __webpack_require__(71).KEY;
var $fails = __webpack_require__(9);
var shared = __webpack_require__(29);
var setToStringTag = __webpack_require__(22);
var uid = __webpack_require__(20);
var wks = __webpack_require__(5);
var wksExt = __webpack_require__(32);
var wksDefine = __webpack_require__(33);
var enumKeys = __webpack_require__(72);
var isArray = __webpack_require__(73);
var anObject = __webpack_require__(7);
var isObject = __webpack_require__(4);
var toIObject = __webpack_require__(11);
var toPrimitive = __webpack_require__(13);
var createDesc = __webpack_require__(12);
var _create = __webpack_require__(39);
var gOPNExt = __webpack_require__(74);
var $GOPD = __webpack_require__(65);
var $DP = __webpack_require__(2);
var $keys = __webpack_require__(25);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(43).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(31).f = $propertyIsEnumerable;
  __webpack_require__(42).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(23)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(6)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(20)('meta');
var isObject = __webpack_require__(4);
var has = __webpack_require__(8);
var setDesc = __webpack_require__(2).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(9)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(25);
var gOPS = __webpack_require__(42);
var pIE = __webpack_require__(31);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(24);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(11);
var gOPN = __webpack_require__(43).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(33)('asyncIterator');


/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(33)('observable');


/***/ }),

/***/ 8:
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ })

/******/ });


// WEBPACK FOOTER //
// apps/apps.js